module.exports = __webpack_public_path__ + "static/img/SF108-90W_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/SF108-90W_1.png
// module id = BrjA
// module chunks = 0